import GameHost from '../games/host/GameHost';
import type { ConceptDef } from './types';

export default function LibraryPlayground({ concept }: { concept: ConceptDef }) {
  return <GameHost key={concept.id} kind={concept.kind} content={concept.config} />;
}
